<template>
  <header id="top-head" class="uk-position-fixed">
    <div class="uk-container uk-container-expand uk-background-primary">
      <nav class="uk-navbar uk-light" data-uk-navbar="mode:click; duration: 250">
        <div class="uk-navbar-left"></div>
        <div class="uk-navbar-right">
          <ul class="uk-navbar-nav">
            <router-link tag="li" :to="{name: 'settings'}" class="uk-visible@m">
              <a
                href="#"
                data-uk-icon="icon: cog"
                title="Einstellungen"
                data-uk-tooltip
              ></a>
            </router-link>
            <li class="uk-visible@m">
              <a
                href="#"
                data-uk-icon="icon: sign-out"
                title="Abmelden"
                data-uk-tooltip
                @click.prevent="logout"
              ></a>
            </li>
            <li class="uk-hidden@m">
              <a
                class="uk-navbar-toggle"
                data-uk-toggle
                data-uk-navbar-toggle-icon
                href="#offcanvas-nav"
                title="Offcanvas"
                data-uk-tooltip
              ></a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions({
      logout: "auth/logout"
    })
  }
};
</script>
